export default __webpack_public_path__ + "img/pin_icons/generator_symbol_w.png";